import React, { Component } from 'react';
import Button from '../../CustomButton';
import './index.css';

class ImageLeft extends Component {
  constructor(props) {
    super(props);
    this.state = {}
    this.clickHandler = this.clickHandler.bind(this);
  }

  clickHandler(e) {
    const { buttonLink } = this.props.content;
    if(buttonLink) {
      window.location.href = buttonLink.link;
      window.location.target = buttonLink.target;
    }
    if(this.props.onClick && typeof this.props.onClick === 'function'){
      this.props.onClick()
    }
  }

  topLayer_JC(){
    const { lang } = this.props;
    if (window.matchMedia('(min-width: 1450px)').matches) {
      if(lang==='en'){ return 'center' }
      else {return '' }
    } else {return''}
  }

  textSec_TA(){
    const { lang } = this.props;
    if (window.matchMedia('(max-width: 520px)').matches) {
      return 'center';
    } else {
      if(lang==='fa'){return 'right'}
      else {return 'left'}
    }
  }

  render() {

    const { lang } = this.props;
    const { bgColor, headerImg, button, textContent } = this.props.content;
    const _bgColor = bgColor ? bgColor : {leftBgClass:'bg-blue', rightBgClass:'bg-cream'};

    return (
      <div className='img-left-section-container'>
        <div className='img-left-section-wrapper'>
        <div className={'img-left-section-right-layer ' + _bgColor.rightBgClass}></div>
          <div className={'img-left-section-left-layer ' + _bgColor.leftBgClass}></div>
          <div className='img-left-section-top-layer'>
            <div className='img-left-section-top-layer-description' style={{justifyContent: this.topLayer_JC()}}>
              <div className='img-left-section-top-ld-w' style={{textAlign:this.textSec_TA()}}>
                <div style={{direction:lang==='fa' ? 'rtl' : 'ltr'}} className='img-left-section-top-ld-dw'>
                  {
                    textContent.map((item, index)=>{
                      return(
                        <div key={item+ index}>
                          <div className='img-left-section-top-ld-hi'>
                            <h1>{lang==='fa' ? item.title.fa : item.title.en}</h1>
                            {
                              item.headerIcon && <div style={{marginLeft: lang==='fa' ? '10px':'', marginRight:lang=== 'en'?'10px':''}} 
                                className={item.bgIconClass? item.bgIconClass :'bg-red'}>
                                {item.headerIcon ? item.headerIcon : lang==="fa" ? '' : ''}
                              </div>
                            }
                          </div>
                          <div className='img-left-section-top-ld-hi'>
                            <p>{lang==='fa' ? item.description.fa :item.description.en}</p>
                            {
                              item.headerIcon && <div style={{marginLeft: lang==='fa' ? '10px':'', marginRight:lang=== 'en'?'10px':'', visibility:'hidden'}}>
                                {item.headerIcon ? item.headerIcon : lang==="fa" ? '' : ''}
                              </div>
                            }
                          </div>
                        </div>
                      )
                    })
                  }
                </div>
                {button && <Button className='img-left-section-tl-button-a button-generic-style' onClick={this.clickHandler}>
                    {lang === 'fa' ? button.textFa : button.textEn} 
                  </Button>
                }
              </div>
            </div>
            <div className='img-left-section-top-layer-img-wrapper'>
              {headerImg ? headerImg : lang==="fa" ? 'بدون عکس' : 'no image'}
              <div className="img-left-section-top-layer-img-shadow"></div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ImageLeft;
